import React, {Component} from 'react'
import '../../index.scss'
export default class First extends Component{

    render(){
        return(
            <div className="FirstBox">
                <div className="FirstBanner">
                </div>
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/awards/components/first/index.js